// 発注などの別画面をタブで起動する処理をまとめる。
// ブラウザのポップアップ制限を避けるため、ユーザー操作直後に空タブを確保してから
// 通信結果で遷移させる。加工指示・品番マスタで同一実装のため共有する。
export function createCallformLauncher(deps) {
    const {
        isEmpty,
        fnc,
        getFormId,
        setPendingOrderLaunches
    } = deps;

    // 入力中セルの確定(blur)を待ってから処理を走らせる。
    function runAfterActiveInputCommit(action) {
        const active = document.activeElement;
        if (!isEmpty(active) && typeof active.blur === 'function') {
            active.blur();
        }
        window.setTimeout(() => {
            if (typeof action === 'function') action();
        }, 0);
    }
    function createPlaceholderTabs(count) {
        const tabs = [];
        if (count <= 0) return tabs;
        const firstTab = window.open("", "_blank");
        preparePlaceholderTab(firstTab);
        tabs.push(firstTab);
        for (let i = 1; i < count; i++) {
            let tab = null;
            try {
                // 環境によっては親タブから複数回 open するより、最初に開いたタブを起点にした方が
                // ユーザー操作由来として扱われやすい。
                tab = firstTab && !firstTab.closed ? firstTab.open("", "_blank") : window.open("", "_blank");
            } catch (error) {
                tab = null;
            }
            preparePlaceholderTab(tab);
            tabs.push(tab);
        }
        return tabs;
    }
    function preparePlaceholderTab(tab) {
        if (tab && !tab.closed) {
            try {
                tab.document.title = "起動中";
            } catch (error) {
            }
        }
    }
    function closePlaceholderTabs(tabs, startIndex = 0) {
        if (!Array.isArray(tabs)) return;
        for (let i = startIndex; i < tabs.length; i++) {
            const tab = tabs[i];
            if (tab && !tab.closed) {
                try {
                    tab.close();
                } catch (error) {
                }
            }
        }
    }
    function buildCallformRequests(action, code, rowdata) {
        const callid = action === "seihin" ? "ShnOrder" : "RawM?type=D_KHD";
        return (Array.isArray(rowdata) ? rowdata : []).map((detail, index) => ({
            index: index,
            callid: callid,
            state: { status: "ENTRY", code: "", accepttype: getFormId(), acceptno: code, mode: action, detail: detail }
        }));
    }
    function callforms(action, code, placeholderTabs = []) {
        //発注情報の収集
        fnc.current.postaxios("kakousiji/GetCallFormStatus", { type: action, keys: code },
            {
                onSuccess: function (data) {
                    fnc.current.wait(false);
                    const requests = buildCallformRequests(action, code, data.rowdata);
                    if (requests.length === 0) {
                        closePlaceholderTabs(placeholderTabs);
                        setPendingOrderLaunches([]);
                        return;
                    }
                    const targetTab = placeholderTabs.length !== 0 ? placeholderTabs[0] : null;
                    const firstOpenedTab = fnc.current.callform(requests[0].state, requests[0].callid, targetTab);
                    closePlaceholderTabs(placeholderTabs, 1);
                    if (firstOpenedTab === null) {
                        setPendingOrderLaunches(requests);
                        fnc.current.warnmsg("ブラウザ制限のため自動で複数タブを開けません。起動一覧から 1 件ずつ開いてください。");
                        return;
                    }
                    const remains = requests.slice(1);
                    setPendingOrderLaunches(remains);
                    //    if (remains.length !== 0) {
                    //        fnc.current.warnmsg("ブラウザ制限のため、残りの起動対象は一覧から開いてください。");
                    //    }
                },
                onError: function () {
                    setPendingOrderLaunches([]);
                    closePlaceholderTabs(placeholderTabs);
                    fnc.current.wait(false);
                }
            }
        );
    }

    return {
        runAfterActiveInputCommit,
        createPlaceholderTabs,
        preparePlaceholderTab,
        closePlaceholderTabs,
        buildCallformRequests,
        callforms
    };
}
